import React from "react";
export const AboutUs = () => {
    return (
        <div className="max-w-6xl mx-auto px-4 pb-16 leading-loose text-justify pt-28">
   
            <h1 className="text-3xl font-bold text-amber-950 mb-6">درباره ما</h1>

            <p className="mb-6 text-gray-800">
                درود عزیزان، <br />
                به <strong>«جاده ابریشم»</strong> خوش آمدید؛ جایی که از دل تاریخ الهام گرفته و امروز با هدف ارائه‌ی اصالت، کیفیت و اعتماد، در صنعت قهوه ایران قدم گذاشته است.
            </p>

            <p className="mb-6 text-gray-800">
                ما در اینجا٬ با تکیه بر سال‌ها تجربه در بازارهای بین‌المللی حالا فعالیت خود را با پخش تخصصی قهوه آغاز کردیم. اکنون، با توسعه زیرساخت‌ها و بهره‌گیری از دانش روز، وارد مرحله‌ای نوین شده‌ایم: راه‌اندازی رُستری اختصاصی با استانداردهای جهانی.
            </p>

            <p className="mb-6 text-gray-800">
                در این مسیر، هر دانه قهوه با وسواس خاصی انتخاب می‌شود. از انتخاب مبدأ و نوع دانه گرفته تا نحوه‌ی رُست و آسیاب، همه‌چیز زیر نظر تیمی حرفه‌ای و بر پایه اصول علمی و تخصصی انجام می‌گیرد. چرا که معتقدیم کیفیت اتفاقی نیست؛ بلکه نتیجه‌ی تعهد، تجربه و دقت در همه مراحل است.
            </p>

            <p className="mb-6 text-gray-800">
                محصولات ما نه‌تنها از نظر طعم و کیفیت، بلکه از نظر بسته‌بندی، انبارداری و حمل‌ونقل نیز با استانداردهای بالا عرضه می‌شوند تا خیال شما از بابت تأمین، همیشه راحت باشد.
            </p>

            <p className="mb-6 text-gray-800">
                تجربه‌ی ما در بازارهای بین‌المللی به ما آموخته است که تأمین به‌موقع، پاسخگویی سریع و پشتیبانی واقعی، پایه‌های اعتماد در یک رابطه تجاری موفق هستند. به همین دلیل، تلاش ما این است که شما بتوانید با خیالی آسوده روی ما حساب کنید — چه یک فروشگاه، کافه، رُستری یا مصرف‌کننده نهایی هستید.
            </p>

            <p className="mb-6 text-gray-800">
                ما در «جاده ابریشم» به دنبال خلق یک تجربه ماندگار هستیم؛ تجربه‌ای که بر پایه‌ی چهار اصل کلیدی بنا شده است:
            </p>

            <ul className="list-none pr-6 text-gray-700 space-y-3">
                <li className="flex items-start gap-2">
                    <span className="text-yellow-500 mt-1">☀️</span>
                    <span>خدمات حرفه‌ای و مسئولانه</span>
                </li>
                <li className="flex items-start gap-2">
                    <span className="text-yellow-500 mt-1">☀️</span>
                    <span>کیفیت ثابت و قابل‌اعتماد</span>
                </li>
                <li className="flex items-start gap-2">
                    <span className="text-yellow-500 mt-1">☀️</span>
                    <span>قیمت‌گذاری منصفانه و شفاف</span>
                </li>
                <li className="flex items-start gap-2">
                    <span className="text-yellow-500 mt-1">☀️</span>
                    <span>تحویل به‌موقع و برنامه‌ریزی‌شده</span>
                </li>
            </ul>

            <p className="mt-8 text-gray-800">
                پس اگر به دنبال طعمی ماندگار، عطری متفاوت و تأمین‌ حرفه‌ای هستید، ما اینجا در کنار شما هستیم. <br />
                با ما، قهوه فقط یک نوشیدنی نیست؛ بخشی از سبک زندگی است.
            </p>
        </div>
    );
};

export default AboutUs;
